import API from 'shared/constants/api';
import { fetchAdvertsWithOmit } from 'shared/helpers/search';

import { removeLocaleFromHref } from 'shared/helpers/locale';

// const isMobile = __APP__ === 'mobile';
// const isClient = process.env.BROWSER;

/**
 * Get links for links blocks.
 * @param {Function} fetch
 * @param {Object} q
 * @returns {Promise<Object>}
 */

const fetchDataForLeasingTemplate = async (fetch, filter) => {
  const result = await fetchAdvertsWithOmit(fetch, filter, 8);
  const specialCars = (result && result.results) || [];
  return { specialCars };
};

export default async function(params) {
  const { fetch, store, baseUrl, path } = params;
  let data = null;
  let otherParams = {};

  const state = store.getState();
  const { locale } = state.globals;

  try {
    const apiURL = removeLocaleFromHref(`${baseUrl}${path}`.replace('//', '/'));
    data = await fetch(API.ARTICLES(apiURL)).then(r => r.json());
    if (data.template.name === 'Leasing') {
      const filter = data.category_avto || '';
      const leasingResult = await fetchDataForLeasingTemplate(fetch, filter);
      otherParams = { ...otherParams, ...leasingResult };
    }
  } catch (e) {
    console.error(e.message);
  }

  const lt = data; // .leasingTitles;
  const spD = 'Специальные предложения';
  const lwD = 'Почему стоит купить авто в лизинг на avtobazar.ua?';
  const condD = 'Условия лизинга автомобиля';
  const postfix = locale !== 'ru' ? `_${locale}` : '';
  const titles = {
    specialPropositions: (lt && (lt[`special_propositions${postfix}`] || spD)) || spD,
    leasingWhy: (lt && (lt[`leasing_why${postfix}`] || lwD)) || lwD,
    // howToPayOff: (lt && (lt[`how_to_pay_off${postfix}`] || condD)) || condD,
    conditions: (lt && (lt[`how_to_pay_off${postfix}`] || condD)) || condD, // TODO: should be changed to 'conditions' key
  };

  const h1 = data[`h1_${locale}`] || data.h1 || '';

  const slug = data.url || '';
  const linksObj = slug
    .replace('leasing', '')
    .split('/')
    .filter(s => !!s);
  const links = [['', 'Автобазар', 'avtobazar'], ['/leasing', 'Лизинг авто', 'lising']];
  const categories = [];
  // TODO: Fix h1 for use deep links
  linksObj.forEach(link => {
    links.push([`/${link}`, h1, link]);
    categories.push(link);
  });
  return {
    ...otherParams,

    breadcrumbsLinks: links,
    slug,
    titles,
    title: data[`title_${locale}`] || data.title || '',
    description: data[`description_${locale}`] || data.description || '',
    h1: data[`h1_${locale}`] || data.h1 || '',
    content: data[`content_${locale}`] || data.content || '',

    categories,
    advertsFilter: data.category_avto || '',
    searchLink: data.referral_slug || '',
    template: data.template && data.template.name,
    category: data.category && data.category.category_slug,
    canonical: data.canonical,

    // filter: null,
    // meta_robots: 0,
    // canonical: null,
    // filter_id: null,
    // filter_redirect: false,
    // redirect: null
  };
}



// WEBPACK FOOTER //
// ./src/shared/routes/article/index.js